import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { educationData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function EducationPage() {
    return <SolutionTemplate {...educationData} />;
}
